require('bootstrap-validator');

$(document).ready(() => {
    let contactForm = $("#contactForm"),
        submitButton = $("#form-submit");

    let formError = () => {
        contactForm.removeClass()
            .addClass('shake animated')
            .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            $(this).removeClass();
        });
    };

    let showMessage = (clazz: string, message: string) => {
        $("#msgSubmit").removeClass()
            .addClass(clazz)
            .text(message);
    };

    let submitForm = (token) => {

        let name = $("#name").val(),
            email = $("#email").val(),
            phone = $("#phone").val(),
            message = $("#message").val();

        $.ajax({
            type: "POST",
            url: contactForm.attr('action'),
            data: {
                name: name,
                email: email,
                phone: phone,
                message: message,
                recaptcha_token: token
            },
            success : function(text){
                if (text == "success"){
                    (<any>contactForm[0]).reset();
                    showMessage('text-success', 'Mensagem enviada com sucesso!');
                } else {
                    formError();
                    showMessage('text-danger',text);
                }
                submitButton.removeAttr("disabled")
                    .text("Enviar")
                    .removeClass('loading');
            }
        });
    };

    contactForm.validator()
        .on("submit", function (event: JQueryEventObject) {
        if (event.isDefaultPrevented()) {
            formError();
            showMessage("text-danger", "Você preencheu todos os campos?");
        } else {
            event.preventDefault();

            submitButton.attr("disabled", "disabled")
                .text("enviando...")
                .addClass('loading');

            if(typeof window.grecaptcha != "undefined") {
                window.grecaptcha.ready(function() {
                    window.grecaptcha.execute('6LegFH4UAAAAADV_ftSGLkrANraMz6MVbfem0o4y', {action: 'contato'}).then(function (token) {
                        submitForm(token);
                    })
                })
            } else {
                submitForm("");
            }
        }
    });

    $(".form-item input").each(function(index, el) {
        let input = $(this);
        if(input.val() === "") {
            input.removeClass('not-empty');
        } else {
            input.addClass('not-empty');
        }

        input.on("change", function() {
            if(input.val() === "") {
                input.removeClass('not-empty');
            } else {
                input.addClass('not-empty');
            }
        });
    });
});


// WEBPACK FOOTER //
// ./src/js/contato.ts